import React, { Component } from 'react'
import PropTypes from 'prop-types'
import LoginForm from '../../Components/User/LoginForm'
import Auth from '../../Modules/Auth'
import { withCookies, Cookies } from 'react-cookie'
import axios from 'axios'
import './LoginPage.scss'
import HeaderLogin from '../../Components/Commons/HeaderLogin'
import queryString from 'query-string'

class LoginPage extends Component {
    constructor(props, context) {
        super(props, context)
        this.redirectUrl = '/'
        this.state = {
            user: {
                username: '',
                password: '',
            },
            idSave: false,
            referrer: 'hausplanner',
        }
    }

    UNSAFE_componentWillMount() {
        const query = queryString.parse(this.props.location.search)
        this.loadCookie()
        if (query.redirect) {
            this.redirectUrl = query.redirect
        }
    }

    loadCookie = () => {
        if (this.props.cookies.get('user_id')) {
            const user = this.state.user
            user['username'] = this.props.cookies.get('user_id')
            this.setState({
                user,
                idSave: true,
            })
        }

        const appName = this.props.cookies.get('app_name')
        if (appName && appName !== '') {
            this.setState({
                referrer: appName,
            })
        }
    }

    processForm = (event) => {
        event.preventDefault()

        const email = this.state.user.username.trim().toLowerCase()
        const password = this.state.user.password
        const referrer = this.state.referrer

        axios
            .post(`/auth/login`, {
                email,
                password,
                referrer,
            })
            .then((res) => {
                console.log(res.data)
                Auth.authenticateUser(res.data.token)

                this.props.toggleAuthenticateStatus()

                const { cookies } = this.props
                const expire = new Date()
                expire.setDate(expire.getDate() + 365)
                cookies.set('demo', false, { path: '/', maxAge: 31536000, expires: expire })

                if (this.state.idSave) {
                    cookies.set('user_id', this.state.user.username, { path: '/', maxAge: 31536000, expires: expire })
                } else {
                    cookies.remove('user_id')
                }

                if (this.redirectUrl !== '/') {
                    this.props.history.push(this.redirectUrl)
                } else {
                    this.props.history.push('/project')
                }
            })
            .catch((err) => {
                alert(
                    '아이디 또는 비밀번호를 다시 확인하세요. 등록되지 않은 아이디이거나, 아이디 또는 비밀번호를 잘못 입력하셨습니다.'
                )
            })
    }

    changeUser = (event) => {
        const field = event.target.name
        const user = this.state.user
        user[field] = event.target.value

        this.setState({
            user,
        })
    }

    toggleChecked = () => {
        this.setState({
            idSave: !this.state.idSave,
        })
    }

    render() {
        return (
            <div>
                <HeaderLogin />
                <div className="section_wrap">
                    <div className="login_wrap common_detail">
                        <div className="section">
                            <LoginForm
                                onSubmit={this.processForm}
                                onChange={this.changeUser}
                                user={this.state.user}
                                idSave={this.state.idSave}
                                toggleChecked={this.toggleChecked}
                                redirect={this.redirectUrl}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

LoginPage.contextTypes = {
    router: PropTypes.object.isRequired,
}

export default withCookies(LoginPage)



// WEBPACK FOOTER //
// ./Src/Containers/User/LoginPage.js